






































































































import { Power, PowerListService } from '@/services/api/usual-power/power-list'
import { UsualPowerService } from '@/services/api/usual-power/usual-power'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    DropdownSelect,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class UsualPowerSettingsPage extends Mixins<PluginMixin>(PluginMixin)  {
  readonly powerListService = new PowerListService()
  readonly usualPowerService = new UsualPowerService()

  submitStatus: Status = Status.Pending

  powerList: Power[] = []
  selectedLeftPower: string = ''
  selectedRightPower: string = ''
  notifyStatus: NotificationStatus = NotificationStatus.None

  get isLoading(): boolean {
    return this.submitStatus === Status.Loading
  }

  get isSubmitCompleted(): boolean {
    return this.notifyStatus === NotificationStatus.PowerUpdateSuccess
  }

  get isSubmitFailed(): boolean {
    return this.notifyStatus === NotificationStatus.PowerUpdateError
  }

  get isGetUserInfoFailed(): boolean {
    return this.notifyStatus === NotificationStatus.UserInfoError
  }

  get isGetPowerListFailed(): boolean {
    return this.notifyStatus === NotificationStatus.PowerListError
  }

  get leftUsualpowerList() {
    return _.map(this.powerList, powerItem => ({
      value: powerItem.pathname,
      text: powerItem.title,
      selected: powerItem.pathname === this.selectedLeftPower,
    }))
  }

  get notificationMessage(): string {
    if (this.notifyStatus === NotificationStatus.PowerUpdateSuccess) return 'いつもの度数を登録しました。'
    if (this.notifyStatus === NotificationStatus.PowerUpdateError) return 'いつもの度数の登録に失敗しました。'
    if (this.notifyStatus === NotificationStatus.UserInfoError) return 'いつもの度数の読み込みに失敗しました。'
    if (this.notifyStatus === NotificationStatus.PowerListError) return 'いつもの度数の読み込みに失敗しました。'

    return ''
  }

  get rightUsualpowerList() {
    return _.map(this.powerList, powerItem => ({
      value: powerItem.pathname,
      text: powerItem.title,
      selected: powerItem.pathname === this.selectedRightPower,
    }))
  }

  async initializePowerList() {
    const response = await this.powerListService.list()
    response.fold(
      (error) => {
        this.notifyStatus = NotificationStatus.PowerListError
        throw new Error(error.message)
      },
      (list) => {
        this.powerList = list
      }
    )
  }

  async initializeUserPowerSetting() {
    const response = await this.usualPowerService.getUserInfo()
    response.fold(
      (error) => {
        this.notifyStatus = NotificationStatus.UserInfoError
        throw new Error(error.message)
      },
      (usualPower) => {
        this.selectedLeftPower = usualPower.leftPathname ? usualPower.leftPathname : ''
        this.selectedRightPower = usualPower.rightPathname ? usualPower.rightPathname : ''
      }
    )
  }
  async created() {
    await Promise.all([
      this.initializeUserPowerSetting(),
      this.initializePowerList(),
    ])
  }

  onLeftPowerSelect(value: string) {
    this.selectedLeftPower = value
  }

  onRightPowerSelect(value: string) {
    this.selectedRightPower = value
  }

  async saveUsualPowers() {
    this.submitStatus = Status.Loading
    const response = await this.usualPowerService.update(
      this.selectedLeftPower,
      this.selectedRightPower
    )
    response.fold(
      (error) => {
        this.submitStatus = Status.Failed
        this.notifyStatus = NotificationStatus.PowerUpdateError

        throw new Error(error.message)
      },
      () => {
        this.submitStatus = Status.Completed
        this.notifyStatus = NotificationStatus.PowerUpdateSuccess
      }
    )
  }
}
enum NotificationStatus {
  None,
  PowerListError,
  UserInfoError,
  PowerUpdateError,
  PowerUpdateSuccess,
}
